const productionHost = "crm.dita.md";
const isPort5173 = typeof window !== 'undefined' && (window.location.port === '5173' || window.location.port === '');

const defaultApiUrl = typeof window !== 'undefined'
  ? (isPort5173 ? '' : (window.location.hostname === productionHost ? `https://${productionHost}:8000` : `http://${window.location.hostname || "localhost"}:6001`))
  : '';

export const API_URL = import.meta.env.VITE_API_URL || defaultApiUrl;
